import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Box, Collapse, List, ListItemButton, ListItemIcon, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';

interface mobileSideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const MobileSideNav: React.FunctionComponent<mobileSideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const [openPeople, setOpenPeople] = useState(false);
  const {
    state: { user },
  } = useContext(AuthContext);

  const handlePeopleClick = () => {
    setOpenPeople(!openPeople);
  };

  const roles = user?.contactRoles || [];
  const isInvestor = ['Strategic Investor', 'Passive Investor'].some((role) => roles?.includes(role));
  const isJuryMember = roles?.includes('Jury Member');
  const hasAllRoles = isInvestor && isJuryMember;

  // const showMenuItem = (roleNeeded: boolean) => roleNeeded || hasAllRoles;
  const showMenuItem = (roleNeeded: boolean) => roleNeeded || hasAllRoles || true;
  const sideNavContents = [
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <HomeOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    // showMenuItem(isInvestor) && {
    //   icon: (isActive: boolean) => <AnalyticsOutlinedIcon className={classes.menuListItemIcon} />,
    //   label: 'My Documents',
    //   link: routes.documents,
    //   name: 'My Documents',
    // },
    // showMenuItem(isInvestor) && {
    //   icon: (isActive: boolean) => <AnalyticsOutlinedIcon className={classes.menuListItemIcon} />,
    //   label: 'FAQ',
    //   link: routes.documents,
    //   name: 'FAQ',
    // },
  ].filter(Boolean);

  const isActive = (link: string) => pathname.startsWith(link);
  const isAnyNestedItemActive = (nestedItems: any[]) => {
    return nestedItems.some((nestedItem) => isActive(nestedItem.link));
  };

  return (
    <>
      {sideNavContents.map((items, index) => {
        if (items.nested) {
          const anyNestedItemActive = isAnyNestedItemActive(items.nestedItems);
          return (
            <div key={index}>
              <ListItemButton onClick={handlePeopleClick} sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }} className={`${classes.menuListItemButton}`}>
                <ListItemIcon sx={{ minWidth: '40px' }}>{items?.icon(items?.nestedItems.some((nestedItem: any) => isActive(nestedItem.link)))}</ListItemIcon>
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography className={`${classes.menuListItemText}`}>{items.label}</Typography>
                  {openPeople ? <ExpandLess sx={{ color: '#333' }} /> : <ExpandMore sx={{ color: '#333' }} />}
                </Box>
              </ListItemButton>
              <Collapse in={openPeople} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {items?.nestedItems.map((nestedItem: any, nestedIndex: any) => (
                    <ListItemButton key={nestedIndex} onClick={() => handleListClick(nestedItem?.link, nestedIndex)} className={`${classes.menuListItemButton}`}>
                      <Box sx={{ ml: 1.5, display: 'flex', alignItems: 'center' }}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>{nestedItem?.icon(isActive(nestedItem?.link))}</ListItemIcon>
                        <Typography className={`${classes.menuListItemText}`}>{nestedItem?.label}</Typography>
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          );
        } else {
          return (
            <ListItemButton
              key={index}
              onClick={() => {
                handleListClick(items?.link, index);
              }}
              sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }}
              className={`${classes.menuListItemButton}`}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>{items?.icon(isActive(items?.link))}</ListItemIcon>
              <Typography className={`${classes.menuListItemText}`}>{items?.label}</Typography>
            </ListItemButton>
          );
        }
      })}
    </>
  );
};

export default MobileSideNav;
